// src/components/common/Toast.jsx - トースト通知コンポーネント

import React, { useEffect } from 'react';
import { COLORS, SPACING, BORDER_RADIUS, SHADOWS } from '../../styles/constants';

const Toast = ({ message, type = 'success', isVisible, onClose, duration = 4000 }) => {
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible) return null;

  const typeStyles = {
    success: {
      background: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
      icon: '✓'
    },
    error: {
      background: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
      icon: '✕'
    },
    info: {
      background: COLORS.primaryGradient,
      icon: 'ℹ'
    },
    warning: {
      background: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
      icon: '!'
    }
  };

  const style = typeStyles[type] || typeStyles.success;

  return (
    <div style={{
      position: 'fixed',
      bottom: '24px',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 9999,
      animation: 'slideInUp 0.3s ease-out'
    }}>
      <div style={{
        background: style.background,
        color: COLORS.white,
        padding: `${SPACING.md} ${SPACING.lg}`,
        borderRadius: BORDER_RADIUS.lg,
        boxShadow: SHADOWS.xl,
        display: 'flex',
        alignItems: 'center',
        gap: SPACING.md,
        maxWidth: '90vw',
        minWidth: '280px'
      }}>
        <div style={{
          width: '28px',
          height: '28px',
          background: 'rgba(255, 255, 255, 0.2)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '700',
          fontSize: '0.875rem',
          flexShrink: 0
        }}>
          {style.icon}
        </div>

        <div style={{
          flex: 1,
          fontSize: '0.9375rem',
          fontWeight: '500',
          lineHeight: '1.4'
        }}>
          {message}
        </div>

        <button
          onClick={onClose}
          style={{
            background: 'rgba(255, 255, 255, 0.2)',
            border: 'none',
            cursor: 'pointer',
            color: COLORS.white,
            width: '24px',
            height: '24px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.875rem',
            flexShrink: 0
          }}
        >
          ×
        </button>
      </div>

      <style>{`
        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default Toast;
